import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomDcpConfiguratorSinglePageFormModule} from '@app/product/configurator/configurator-components/cps-configurator/dcp-configurator-single-page-form/custom-dcp-configurator-single-page-form.module';
import {OrderUpsellBundleCtaModule} from '@app/product/configurator/configurator-components/order-upsell-bundle-cta/order-upsell-bundle-cta.module';
import {GroupSkipDirective} from '@dcp/accessibility';
import {
  DcpConfiguratorAddToCartButtonModule,
  DcpConfiguratorAttributeAddonCheckboxModule,
  DcpConfiguratorAttributeAddonMultiValueModule,
  DcpConfiguratorAttributeAddonRadiobuttonModule,
  DcpConfiguratorAttributeCheckboxListModule,
  DcpConfiguratorAttributeCheckboxModule,
  DcpConfiguratorAttributeDropDownModule,
  DcpConfiguratorAttributeInputAndDateInputFieldModule,
  DcpConfiguratorAttributeQuantityModule,
  DcpConfiguratorAttributeRadioButtonModule,
  DcpConfiguratorAttributeReadOnlyModule,
  DcpConfiguratorAttributeSpendAmount,
  DcpConfiguratorPriceSummaryModule,
  DcpConfiguratorProductTitleModule,
  DcpConfiguratorUpdateMessageModule,
} from '@dcp/configurator';
import {I18nModule} from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDcpConfiguratorSinglePageFormModule,
    DcpConfiguratorProductTitleModule,
    DcpConfiguratorUpdateMessageModule,
    DcpConfiguratorPriceSummaryModule,
    DcpConfiguratorAddToCartButtonModule,
    DcpConfiguratorAttributeDropDownModule,
    DcpConfiguratorAttributeRadioButtonModule,
    DcpConfiguratorAttributeReadOnlyModule,
    DcpConfiguratorAttributeQuantityModule,
    DcpConfiguratorAttributeInputAndDateInputFieldModule,
    DcpConfiguratorAttributeAddonMultiValueModule,
    DcpConfiguratorAttributeAddonCheckboxModule,
    DcpConfiguratorAttributeCheckboxModule,
    DcpConfiguratorAttributeCheckboxListModule,
    DcpConfiguratorAttributeSpendAmount,
    OrderUpsellBundleCtaModule,
    DcpConfiguratorAttributeAddonRadiobuttonModule,
    GroupSkipDirective,
  ],
})
export class ConfiguratorComponentsModule {}
